var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaas(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.359 6.36a1.085 1.085 0 01-.721-.732 8 8 0 00-15.49.841 7.652 7.652 0 00.8 5.18A5.446 5.446 0 00.06 17.3 5.844 5.844 0 005.686 22h9.1c5.073 0 8.852-3.028 9.19-7.362a7.963 7.963 0 00-5.617-8.278zm.872 7.347l-5.415 5.414a3 3 0 01-4.242 0L6.187 15.7a1 1 0 111.416-1.4l3.384 3.414a1.025 1.025 0 001.41 0l5.415-5.414a1 1 0 011.415 1.414l.004-.007z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaas);
export default __webpack_public_path__ + "static/media/saas.a295cce36102cc40f32a427e7d72ad00.svg";
export { ForwardRef as ReactComponent };